import { router, useFocusEffect } from 'expo-router';
import { useCallback, useRef } from 'react';
import { StyleSheet } from 'react-native';

import { Button, Favicon, IconRewards3D, Text, YStack, tokens } from '@fhs/ui';
import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

function RewardsLockup() {
  return (
    <YStack
      style={styles.rewardsLockup}
      accessible
      accessibilityLabel="Firehouse Rewards. Join. Earn. Redeem."
    >
      <Favicon size={60} aria-hidden />
      <IconRewards3D size={208} aria-hidden />
      <Text weight="bold" style={styles.rewardsTagline}>
        JOIN. EARN. REDEEM.
      </Text>
    </YStack>
  );
}

export function LoggedOutHeader() {
  const { setOriginLocation } = useAuthContext();
  const isOpeningAuth = useRef(false);

  useFocusEffect(
    useCallback(() => {
      isOpeningAuth.current = false;
    }, [])
  );

  return (
    <YStack style={styles.container}>
      <RewardsLockup />
      <YStack style={styles.callToAction}>
        <Text style={styles.valueCopy}>
          Earn points toward rewards and enjoy member-only perks, including a birthday reward and up
          to $10 off your first order.
        </Text>
        <Button
          size="md"
          accessibilityRole="button"
          accessibilityLabel="Log In or Sign Up"
          hitSlop={4}
          onPress={() => {
            // Block repeat taps synchronously, before the navigation transition starts.
            if (isOpeningAuth.current) {
              return;
            }
            isOpeningAuth.current = true;
            setOriginLocation(routes.account);
            router.push(routes.signInV2);
          }}
          style={styles.loginButton}
        >
          <Button.Text>Log In / Sign Up</Button.Text>
        </Button>
      </YStack>
    </YStack>
  );
}

const styles = StyleSheet.create({
  container: { alignItems: 'center', gap: 12, paddingHorizontal: 8, paddingTop: 16 },
  rewardsLockup: { alignItems: 'center', gap: 12, width: '100%' },
  rewardsTagline: { fontFamily: 'HeroSerifBold', fontSize: 16, lineHeight: 19 },
  callToAction: { alignItems: 'center', gap: 24, width: '100%' },
  valueCopy: { fontSize: 14, lineHeight: 20, textAlign: 'center' },
  loginButton: {
    backgroundColor: tokens.colors.$bottomNavigationActive,
    borderColor: tokens.colors.$bottomNavigationActive,
    height: 37,
    width: '100%',
  },
});
